import { createSelector, createFeatureSelector } from '@ngrx/store';
import { BannersState } from '../_reducers/banners.reducer';
import { BannerModel } from '../../_models/banner.model';

export const selectBannersState = createFeatureSelector<BannersState>('banners');

export const currentBanner = createSelector(
  selectBannersState,
  (banners: BannersState) => new BannerModel(banners.selected)
);

export const currentBannersList = createSelector(
  selectBannersState,
  (banners: BannersState) =>
    banners.list.data.map((banner) => new BannerModel(banner))
);

export const currentBannersTotal = createSelector(
  selectBannersState,
  (banners: BannersState) => banners.list.total
);

export const currentBannersFilters = createSelector(
  selectBannersState,
  (banners: BannersState) => banners.list.filters
);

export const currentActiveBanners = createSelector(
  currentBannersList,
  (banners: BannerModel[]) => banners.filter(b => b.active)
);

export const currentInactiveBanners = createSelector(
  currentBannersList,
  (banners: BannerModel[]) => banners.filter(b => !b.active)
);

export const currentActiveCount = createSelector(
  selectBannersState,
  (banners: BannersState) => banners.list.activeCount
);
